import { FeatureFlag } from 'App/Components/FeatureFlag/FeatureFlag';
import CampaignsIcon from 'App/assets/img/campaigns.svg?url';
import CandidatesIcon from 'App/assets/img/candidates.svg?url';
import DashboardIcon from 'App/assets/img/dashboard.svg?url';
import PersonasIcon from 'App/assets/img/personas.svg?url';
import { Campaigns } from 'Views/Campaigns/Campaigns';
import { Campaign } from 'Views/Campaigns/components/Campaign/Campaign';
import { NewCampaign } from 'Views/Campaigns/components/NewCampaign/NewCampaign';
import { Candidates } from 'Views/Candidates/Candidates';
import { CandidateForm } from 'Views/Candidates/components/CandidateForm/CandidateForm';
import { Dashboard } from 'Views/Dashboard/Dashboard';
import { Employees } from 'Views/Employees/Employees';
import { Employee } from 'Views/Employees/components/Employee/Employee';
// import { Employee } from 'Views/Employees/components/Employee/Employee';
import { Files } from 'Views/Files/Files';
import { HealthRiskAssessmentWrapper } from 'Views/HealthRiskAssessment/HealthRiskAssessmentWrapper';
import { Home } from 'Views/Home/Home';
import { JobProfile } from 'Views/JobProfile/JobProfile';
import NotAuthorized from 'Views/NotAuthorized/NotAuthorized';
import { ReportNom024 } from 'Views/ReportNom024/ReportNom024';
import { Users } from 'Views/Users/Users';
import { CompanyPermissions } from 'constants/companyPermissions';
import { useAuth } from 'hooks/useAuth';
import {
	checkFunctionalityPermission,
	checkHRAPermission,
} from 'utils/checkFunctionalityPermission';

export const useAuthorizedRoutes = () => {
	const { isAuthenticated } = useAuth();
	return [
		{
			active: isAuthenticated ? true : false,
			path: '/',
			label: 'Home',
			component: Home,
			isMenu: true,
		},
		{
			active: isAuthenticated
				? checkFunctionalityPermission(CompanyPermissions.dashboard.id)
				: false,
			path: '/dashboard',
			label: 'Dashboard',
			component: Dashboard,
			isMenu: true,
			icon: DashboardIcon,
		},
		{
			active: isAuthenticated
				? checkFunctionalityPermission(CompanyPermissions.nom035.id)
				: false,
			path: '/campaigns',
			label: 'Campañas',
			component: () =>
				FeatureFlag({
					children: Campaigns,
					feature: 'campaigns',
					fallback: true,
				}),
			isMenu: true,
			icon: CampaignsIcon,
		},
		{
			active: isAuthenticated
				? checkFunctionalityPermission(CompanyPermissions.nom035.id)
				: false,
			path: '/campaign/:id?',
			label: 'Campaña',
			component: Campaign,
			isMenu: false,
		},
		{
			active: isAuthenticated
				? checkFunctionalityPermission(CompanyPermissions.nom035.id)
				: false,
			path: '/campaigns/new/:id',
			label: 'Nueva Campaña',
			component: NewCampaign,
			isMenu: false,
		},
		{
			active: isAuthenticated
				? checkFunctionalityPermission(CompanyPermissions.employees.id)
				: false,
			path: '/employees/:jobProfileType?/:riskId?',
			label: 'Employees',
			component: () =>
				FeatureFlag({
					children: Employees,
					feature: 'employees',
					fallback: true,
				}),
			isMenu: true,
			icon: PersonasIcon,
		},
		{
			active: isAuthenticated
				? checkFunctionalityPermission(CompanyPermissions.employees.id)
				: false,
			path: '/employee/:id?',
			label: 'Employees',
			component: Employee,
			isMenu: false,
		},
		{
			active: isAuthenticated
				? checkFunctionalityPermission(CompanyPermissions.candidates.id)
				: false,
			path: '/candidates',
			label: 'Candidates',
			component: () =>
				FeatureFlag({
					children: Candidates,
					feature: 'candidates',
					fallback: true,
				}),
			isMenu: true,
			icon: CandidatesIcon,
		},
		{
			active: isAuthenticated
				? checkFunctionalityPermission(CompanyPermissions.candidates.id)
				: false,
			path: '/candidates/:mode/:id?/:step?',
			label: 'Candidate',
			component: CandidateForm,
			isMenu: false,
		},
		{
			active: isAuthenticated
				? checkFunctionalityPermission(CompanyPermissions.users.id)
				: false,
			path: '/users',
			label: 'Users',
			component: Users,
			isMenu: false,
		},
		{
			active: isAuthenticated ? true : false,
			path: '/not-authorized',
			label: 'Not Authorized',
			component: NotAuthorized,
			isMenu: false,
		},
		{
			active: isAuthenticated ? true : false,
			path: '/files',
			label: 'Files',
			feature: 'files',
			component: () =>
				FeatureFlag({
					children: Files,
					feature: 'files',
					fallback: true,
				}),
			isMenu: true,
		},
		{
			active: isAuthenticated ? checkHRAPermission() : false,
			path: '/health-risk-assessment',
			label: 'HRA',
			component: HealthRiskAssessmentWrapper,
			isMenu: false,
		},
		{
			active: isAuthenticated ? true : false,
			path: '/report-nom',
			label: 'Reporte NOM-024',
			component: ReportNom024,
			isMenu: false,
		},
		{
			active: isAuthenticated
				? checkFunctionalityPermission(CompanyPermissions.jobProfiles.id)
				: false,
			path: [
				'/job-profile',
				'/job-profile/profile/:jobProfileType/:id?',
				'/job-profile/risk-factors/:jobProfileType/:id/:riskId?',
				'/job-profile/summary/:jobProfileType/:id',
			],
			label: 'JobProfile',
			feature: 'jobProfile',
			component: () =>
				FeatureFlag({
					children: JobProfile,
					feature: 'jobProfile',
					fallback: true,
				}),
			isMenu: true,
		},
	];
};
